import { SVGProps } from 'react'

const IssuanceIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={8.792} cy={12.002} r={7.292} stroke="currentColor" />
    <circle cx={15.208} cy={12.002} r={7.292} stroke="currentColor" />
  </svg>
)

export default IssuanceIcon
